import { render, staticRenderFns } from "./ITRQConsentsStep.vue?vue&type=template&id=5659d63e&scoped=true&"
import script from "./ITRQConsentsStep.vue?vue&type=script&lang=ts&"
export * from "./ITRQConsentsStep.vue?vue&type=script&lang=ts&"
import style0 from "./ITRQConsentsStep.vue?vue&type=style&index=0&id=5659d63e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5659d63e",
  null
  
)

export default component.exports